var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3332 5.00065C18.3332 4.08398 17.5832 3.33398 16.6665 3.33398H3.33317C2.4165 3.33398 1.6665 4.08398 1.6665 5.00065M18.3332 5.00065V15.0007C18.3332 15.9173 17.5832 16.6673 16.6665 16.6673H3.33317C2.4165 16.6673 1.6665 15.9173 1.6665 15.0007V5.00065M18.3332 5.00065L9.99984 10.834L1.6665 5.00065",
    stroke: "#667085",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.29869b1cd208b97836c03f112d7defec.svg";
export { ForwardRef as ReactComponent };